(function () {
  const DESKTOP_QUERY = '(min-width: 750px)';

  const VALID_VALUE =
    /^(0|auto|unset|initial|inherit|-?\d*\.?\d+(px|rem|em|%|vh|vw))$/;

  const PROPERTY_MAP = {
    'padding-block-start': 'paddingBlockStart',
    'padding-block-end': 'paddingBlockEnd',
    'padding-inline-start': 'paddingInlineStart',
    'padding-inline-end': 'paddingInlineEnd',
    'max-width': 'maxWidth',
    'width': 'width',
  };

  const properties = Object.keys(PROPERTY_MAP);

  const selector = properties
    .map((property) => `[class*="${property}-["]`)
    .join(', ');

  function getValue(className, property, device = '') {
    const prefix = device ? `${device}-` : '';

    const match = className.match(
      new RegExp(`^${prefix}${property}-\\[(.+)\\]$`)
    );

    return match ? match[1] : null;
  }

  function applyUtilities(scope = document) {
    const isDesktop = window.matchMedia(DESKTOP_QUERY).matches;

    const elements = scope.matches?.(selector)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(selector) || []);

    elements.forEach((el) => {
      properties.forEach((property) => {
        let value = null;

        el.classList.forEach((className) => {
          const base = getValue(className, property);
          const mobile = getValue(className, property, 'mobile');
          const desktop = getValue(className, property, 'desktop');

          if (base && VALID_VALUE.test(base)) {
            value = base;
          }

          if (!isDesktop && mobile && VALID_VALUE.test(mobile)) {
            value = mobile;
          }

          if (isDesktop && desktop && VALID_VALUE.test(desktop)) {
            value = desktop;
          }
        });

        if (value) {
          el.style[PROPERTY_MAP[property]] = value;
        }
      });
    });
  }

  function initUtilities() {
    applyUtilities();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          applyUtilities(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    window.matchMedia(DESKTOP_QUERY).addEventListener('change', () => {
      applyUtilities();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUtilities);
  } else {
    initUtilities();
  }
})();